<script lang="ts">
import { defineComponent, h, Fragment } from 'vue';
import { hasSlotContent } from '@components/slots';

/**
 * Renders an ul element that wraps each element passed into the pill
 * slot in an li.
 *
 */
export default defineComponent({
  name: 'CodePillList',

  functional: true,

  props: {
    justify: {
      type: String,
      default: 'end',
    },

    wrapColumn: {
      type: Boolean,
      default: true,
    },
  },

  render() {
    const { pill, action } = this.$slots;

    const listItems = pill().flatMap((item) => {
      if (item.type === Fragment && Array.isArray(item.children)) {
        return item.children.map((child) => h('li', {}, [child]));
      }

      return h('li', {}, [item]);
    });

    if (hasSlotContent(action)) {
      listItems.push(h('li', {}, action()));
    }

    return h(
      'ul',
      {
        ...this.$attrs,
        class: [
          'code-pill-list',
          `code-pill-list--${this.justify}`,
          this.wrapColumn ? 'code-pill-list' : 'code-pill-list--nowrap',
          this.$attrs.class,
        ],
      },
      listItems
    );
  },
});
</script>

<style lang="scss">
@use 'settings/settings';

.code-pill-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100% !important;
}

.code-pill-list--left {
  justify-content: start;
  justify-items: start;
}

.code-pill-list {
  display: flex;
  flex-flow: row wrap;
  gap: settings.$codePillListGap * 1px;
}

.code-pill-list--nowrap {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  grid-gap: settings.$codePillListGap * 1px;
}
</style>
